export default __webpack_public_path__ + "static/media/parsehub.5af10823.svg";